import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;

  position: relative;
  padding: 0 0 10px;
  width: 100%;
  max-width: ${themeGet('document.maxWidth')};
  margin: 0 auto;
  height: 124px;
  width: calc(100vw - 5rem);
  img {
    width: 100%;
  }
  & > a.internalStyledLink {
    background-color: ${themeGet('colors.whiteSnow')};
    border-radius: 100%;
    width: 134px;
    height: 109px;
    position: relative;
    top: 20px;
    left: -10px;
    z-index: 105;
    flex: 0 0 auto;
    .home-link {
      width: 114px;
      height: 98px;
      left: 11px;
      top: 4px;
      /*
      min-width: 114px;
      position: relative;
      z-index: 105;
      top: 20px;
      background-color: white;
      border-radius: 50%;
      padding: 0 15px 15px 15px;
      box-sizing: content-box;
      left: -5px;
      margin-top: -15px;
      */
    }
  }

  nav.primary {
    a {
      color: ${themeGet('colors.spinTextDark')};
      margin-bottom: 0;
    }
  }
  @media screen and (max-width: ${themeGet('breakpoints.lg')}) {
    left: 0;
    background-color: ${themeGet('colors.transparent')};
    height: 70px;
    z-index: 100;
    padding: 0;
    a.internalStyledLink {
      top: -3px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      z-index: 105;
      width: 107px;
      height: 103px;
      margin-bottom: 0;
      background-color: none;
      .home-link {
        border-radius: 100%;
        position: absolute;
        top: 20px;
        left: 50%;
        margin-top: 0;
        transform: translateX(-50%);
        width: 85px;
        height: 72px;
        min-width: auto;
        padding: 0;
        z-index: 105;
      }
    }
  }
`;
